// extracted by mini-css-extract-plugin
export default {"input":"PersonListDashboardWidget_input__l-GWW"};